
(function notificationConfigModuleDefinition() {

    'use strict';
    
    angular.module('NotificationConfig', ['ui.router', 'Config', 'Entities', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function notificationConfig(config, $stateProvider, loginProvider) {
                     
                $stateProvider.state('notification-config-find', {
                    url: "/NotificationConfig/List",
                    templateUrl: config.resourceUrl('/views/notification-config/list.html'),
                    controller: 'NotificationConfigFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('NOTIFICATION READ').or('NOTIFICATION WRITE') 
                });

                $stateProvider.state('notification-config-add', {
                    url: "/NotificationConfig/Add",
                    templateUrl: config.resourceUrl('/views/notification-config/add.html'),
                    controller: 'NotificationConfigAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('NOTIFICATION WRITE')
                });

                $stateProvider.state('notification-config-edit', {
                    url: "/NotificationConfig/Edit/{id}",
                    templateUrl: config.resourceUrl('/views/notification-config/edit.html'),
                    controller: 'NotificationConfigEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('NOTIFICATION WRITE')
                });

                $stateProvider.state('notification-config-detail', {
                    url: "/NotificationConfig/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/notification-config/detail.html'),
                    controller: 'NotificationConfigDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('NOTIFICATION READ').or('NOTIFICATION WRITE') 
                });

            }
        ]);
})();